import { KNOWI_DASHBOARD_IDS } from 'config';

export type KnowiFilterType = 'community_id' | 'b2b_customer';

export const KNOWI_DASHBOARD_FILTER_CONFIG: Partial<Record<string, KnowiFilterType[]>> = {
  ADVANCED_SHIFT_FULFILLMENT: ['community_id', 'b2b_customer'],
  SHIFT_CREATION_DASHBOARD: ['community_id', 'b2b_customer'],
  ABSENCE_DASHBOARD: ['community_id', 'b2b_customer'],
  CANCELLATION_DASHBOARD: ['community_id', 'b2b_customer'],
  CALL_OUT_PERFORMANCE_REPORTS: ['community_id', 'b2b_customer'],
  WORKFORCE_FULFILLMENT_OPERATIONS_EFFICIENCY: ['community_id', 'b2b_customer'],
  LABOR_PRODUCTIVITY_ENGAGEMENT: ['community_id', 'b2b_customer'],
  OVERTIME_DASHBOARD: ['community_id', 'b2b_customer'],
  LABOR_COST_OPTIMIZATION: ['community_id', 'b2b_customer'],
  AGENCY_DASHBOARD: ['community_id', 'b2b_customer'],
  EMPLOYEE_ENGAGEMENT: ['community_id', 'b2b_customer'],
};

export const knowiDashboardFilterMap: Map<string, KnowiFilterType[]> = (() => {
  const map = new Map<string, KnowiFilterType[]>();
  for (const [key, filters] of Object.entries(KNOWI_DASHBOARD_FILTER_CONFIG)) {
    const token = KNOWI_DASHBOARD_IDS[key as keyof typeof KNOWI_DASHBOARD_IDS];
    if (token && filters) map.set(token, filters);
  }
  return map;
})();

export type ReportMenuItemStatus = 'active' | 'coming_soon';

export const REPORTS_CONSTANTS = {
  MENU_ITEMS: [
    {
      id: 'overview',
      label: 'Overview',
      path: '/reports/overview',
      dashboardIdKey: undefined as string | undefined,
      isPremiumTier: false,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'fulfillment',
      label: 'Workforce Fulfillment & Operations',
      path: '/reports/fulfillment',
      dashboardIdKey: undefined as string | undefined,
      isPremiumTier: false,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'overtime-custom',
      label: 'Weekly Overtime Dashboard',
      path: '/reports/overtime-custom',
      dashboardIdKey: undefined as string | undefined,
      isPremiumTier: false,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'overtime-daily',
      label: 'Daily Overtime Dashboard',
      path: '/reports/overtime-daily',
      dashboardIdKey: undefined as string | undefined,
      isPremiumTier: false,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'labor-cost',
      label: 'Labor Cost Optimization',
      path: '/reports/labor-cost',
      dashboardIdKey: undefined as string | undefined,
      isPremiumTier: false,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'employee-engagement',
      label: 'Employee Engagement',
      path: '/reports/employee-engagement',
      dashboardIdKey: undefined as string | undefined,
      isPremiumTier: false,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'labor-productivity-custom',
      label: 'Labor Productivity & Engagement',
      path: '/reports/labor-productivity',
      dashboardIdKey: undefined as string | undefined,
      isPremiumTier: false,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'agency',
      label: 'Agency Dashboard',
      path: '/reports/agency',
      dashboardIdKey: undefined as string | undefined,
      isPremiumTier: false,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'advanced-shift-fulfillment',
      label: 'Advanced Shift Fulfillment',
      path: '/reports/advanced-shift-fulfillment',
      dashboardIdKey: 'ADVANCED_SHIFT_FULFILLMENT',
      isPremiumTier: false,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'shift-creation-dashboard',
      label: 'Shift Creation Dashboard',
      path: '/reports/shift-creation-dashboard',
      dashboardIdKey: 'SHIFT_CREATION_DASHBOARD',
      isPremiumTier: false,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'absence',
      label: 'Absence Dashboard',
      path: '/reports/absence',
      dashboardIdKey: 'ABSENCE_DASHBOARD',
      isPremiumTier: false,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'cancellation',
      label: 'Absence Data',
      path: '/reports/cancellation',
      dashboardIdKey: 'CANCELLATION_DASHBOARD',
      isPremiumTier: false,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'call-out-performance',
      label: 'Call Out Performance Reports',
      path: '/reports/call-out-performance',
      dashboardIdKey: 'CALL_OUT_PERFORMANCE_REPORTS',
      isPremiumTier: false,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'workforce-fulfillment-operation-efficiency',
      label: 'Workforce Fulfillment & Operation Efficiency',
      path: '/reports/workforce-fulfillment-operation-efficiency',
      dashboardIdKey: 'WORKFORCE_FULFILLMENT_OPERATIONS_EFFICIENCY',
      isPremiumTier: true,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'labor-productivity-engagement',
      label: 'Labor Productivity & Engagement',
      path: '/reports/labor-productivity-engagement',
      dashboardIdKey: 'LABOR_PRODUCTIVITY_ENGAGEMENT',
      isPremiumTier: true,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'overtime-dashboard',
      label: 'Overtime Dashboard',
      path: '/reports/overtime-dashboard',
      dashboardIdKey: 'OVERTIME_DASHBOARD',
      isPremiumTier: true,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'labor-cost-optimization',
      label: 'Labor Cost Optimization',
      path: '/reports/labor-cost-optimization',
      dashboardIdKey: 'LABOR_COST_OPTIMIZATION',
      isPremiumTier: true,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'agency-dashboard',
      label: 'Agency Dashboard',
      path: '/reports/agency-dashboard',
      dashboardIdKey: 'AGENCY_DASHBOARD',
      isPremiumTier: true,
      status: 'active' as ReportMenuItemStatus,
    },
    {
      id: 'employee-engagement',
      label: 'Employee Engagement',
      path: '/reports/employee-engagement',
      dashboardIdKey: 'EMPLOYEE_ENGAGEMENT',
      isPremiumTier: true,
      status: 'active' as ReportMenuItemStatus,
    },
  ],
} as const;

export type ReportMenuItem = typeof REPORTS_CONSTANTS.MENU_ITEMS[number];

export const HIDDEN_REPORT_MENU_ITEM_IDS: ReadonlySet<string> = new Set([]);

export const getVisibleReportMenuItems = (
  isPremiumDashboardTierEnabled: boolean,
): ReportMenuItem[] =>
  REPORTS_CONSTANTS.MENU_ITEMS.filter((item) => {
    if (HIDDEN_REPORT_MENU_ITEM_IDS.has(item.id)) return false;
    if (item.isPremiumTier && !isPremiumDashboardTierEnabled) return false;
    return !item.dashboardIdKey;
  });

export const getDefaultDashboardPath = (
  isPremiumDashboardTierEnabled: boolean,
): string | undefined =>
  getVisibleReportMenuItems(isPremiumDashboardTierEnabled).find((item) => item.status === 'active')
    ?.path;

export const NATIVE_DASHBOARD_PATHS: string[] = [
  '/reports/overview',
  '/reports/fulfillment',
  '/reports/overtime-custom',
  '/reports/overtime-daily',
  '/reports/labor-cost',
  '/reports/agency',
  '/reports/employee-engagement',
  '/reports/labor-productivity',
];
